import React, { useEffect, useState } from "react";
import { X, Plus } from "lucide-react";
import api, { formatApiError } from "../../api";
import { btnPrimary, inputCls, panel } from "./ui";

export default function SettingsPanel() {
  const [values, setValues] = useState([]);
  const [draft, setDraft] = useState("");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    api.get("/settings").then(({ data }) => setValues(data.qualitativeScale));
  }, []);

  const save = async () => {
    try {
      const { data } = await api.put("/settings", { qualitativeScale: values });
      setValues(data.qualitativeScale);
      setMsg("Guardado.");
    } catch (ex) {
      setMsg(formatApiError(ex));
    }
  };
  const add = (e) => {
    e.preventDefault();
    const v = draft.trim();
    if (v && !values.includes(v)) setValues([...values, v]);
    setDraft("");
  };

  return (
    <div className={`${panel} max-w-xl space-y-4`} data-testid="eid-admin-settings">
      <div>
        <h3 className="font-semibold text-[15px]">Valoraciones cualitativas</h3>
        <p className="text-[12px] text-[#132C44]/60 mt-1">
          Se eligen manualmente en cada evaluación y no dependen de la nota numérica. Las evaluaciones ya registradas conservan su valoración.
        </p>
      </div>
      <div className="flex flex-wrap gap-2" data-testid="eid-settings-values">
        {values.map((v) => (
          <span key={v} className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-[#8AA986]/20 text-[13px]">
            {v}
            <button onClick={() => setValues(values.filter((x) => x !== v))} aria-label={`Quitar ${v}`} data-testid={`eid-settings-remove-${v}`}>
              <X className="h-3 w-3" />
            </button>
          </span>
        ))}
      </div>
      <form onSubmit={add} className="flex gap-2">
        <input className={inputCls} value={draft} onChange={(e) => setDraft(e.target.value)} placeholder="Nueva valoración" maxLength={40} data-testid="eid-settings-new" />
        <button type="submit" className="rounded-lg border border-[#132C44]/20 px-3" aria-label="Agregar" data-testid="eid-settings-add"><Plus className="h-4 w-4" /></button>
      </form>
      <div className="flex items-center gap-3">
        <button onClick={save} disabled={!values.length} className={btnPrimary} data-testid="eid-settings-save">Guardar cambios</button>
        {msg && <span className="text-[12px]" data-testid="eid-settings-msg">{msg}</span>}
      </div>
    </div>
  );
}
